export default __webpack_public_path__ + "static/media/sthetoscope.6af90c55.svg";